module.exports = __webpack_public_path__ + "img/doc-validation.92d82f58.svg";